import React from 'react'
import { type Parser, domParser } from '.'
import { Element } from 'html-react-parser'
import { ModalToDialog } from './modal-parser-effects'

// Some CMS-pages use a Bootstrap 3 modal-component that only exists in the legacy-web
// Therefore we need to convert these modals to our own dialog-component

export const modalParser: Parser = (node, additionalMacros, additionalNodeParsers) => {
  if (
    node.type === 'tag' &&
    node.attribs['class']?.includes('modal') &&
    node.attribs['class']?.includes('fade')
  ) {
    const modal = node

    const modalId = modal.attribs['id']

    const findModalChild = (parent: Element, className: string) =>
      parent.children.find(n => {
        if (n.type === 'tag') {
          const el = n
          return el.attribs['class']?.includes(className)
        }
      }) as Element

    const modalDialog = findModalChild(modal, 'modal-dialog')
    const modalContent = findModalChild(modalDialog, 'modal-content')
    const children = domParser(
      modalContent?.children ?? modal.children,
      additionalMacros,
      additionalNodeParsers
    )

    if (!modalId) {
      return null
    }

    return <ModalToDialog modalId={modalId}>{children}</ModalToDialog>
  } else {
    return
  }
}
